import React from "react";
import MDEditor from '@uiw/react-md-editor';
import {useAppDispatch, useAppSelector} from "../hooks";
import {selectCurrentLog, setLogEditor} from "../redux/ui";
import useApi from "../api/useApi";
import {selectUser} from "../redux/auth";
import {selectFrontingMembers} from "../redux/members";
import {addLogEntry, updateLogEntry} from "../redux/logs";

export default function LogEditor() {
  const currentLog = useAppSelector(selectCurrentLog)
  const [initialValue, setInitialValue] = React.useState(currentLog?.entry || '')
  const [value, setValue] = React.useState<string>(currentLog?.entry || '');
  const dispatch = useAppDispatch()

  const user = useAppSelector(selectUser)
  const fronts = useAppSelector(selectFrontingMembers)
  const { logs } = useApi()

  const handleKeyPress = async (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.ctrlKey && e.key === 's') {
      e.preventDefault()
      e.stopPropagation()
      console.log('saving log entry...')

      setInitialValue(value)

      if (!user || !user.defaultSystemId) {
        console.log('cannot save log, no user/default system')
      } else {
        if (currentLog && currentLog.id) {
          //editing
          const log = await logs.updateLog(currentLog.id, {
            entry: value
          })
          dispatch(updateLogEntry(log))
        } else {
          //adding
          const log = await logs.addLog(user.defaultSystemId, {
            entry: value,
            authorIds: fronts.map((f) => f.id)
          })
          dispatch(addLogEntry(log))
          console.log('log saved', log)
        }
      }
    }

    if (e.ctrlKey && e.key === 'c') {
      e.preventDefault()
      e.stopPropagation()

      //quitting
      let sure = true
      if (value !== initialValue) {
        // eslint-disable-next-line no-restricted-globals
        sure = confirm('Are you sure you want to discard your log entry?')
      }

      if (sure) {
        dispatch(setLogEditor(false))
      }
    }
  };

  return (
    <div className="container">
      <MDEditor
        value={value}
        onChange={(value) => setValue(value || '')}
        fullscreen={true}
        onKeyDown={(e) => handleKeyPress(e)}
        preview={'live'}
        autoFocus={true}
        autoFocusEnd={true}
      />
      <MDEditor.Markdown source={value} style={{ whiteSpace: 'pre-wrap' }} />
    </div>
  );
}